// Module
var code = "<div class=\"unique-selling-point\" ng-class=\"{ 'unique-selling-point--mobile-hidden': $ctrl.hideOnMobile }\" ng-bind-html=\"::$ctrl.family.uniqueSellingPoint\"> </div> ";
// Exports
module.exports = code;